import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MdlModule } from '@angular-mdl/core';
import { MdlSelectModule } from '@angular-mdl/select';
import { AccordionModule } from "ngx-accordion";

import { PatientAppViewRoutingModule } from './patient-app-view-routing.module';
import { DirectivesModule } from '.././directives/directives.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CopyrightFooterModule } from '../shared/components/copyright-footer/copyright-footer.module';

import { TranslateModule } from '../translate/translate.module';
import { PipeModule } from '../pipes/pipes.module';


import { SharedService } from '../shared/services/shared.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        MdlModule,
        MdlSelectModule,
        AccordionModule,
        PatientAppViewRoutingModule,
        TranslateModule,
        PipeModule ,
        DirectivesModule,
        CopyrightFooterModule
    ],
    declarations: [
        ResetPasswordComponent
    ],
    providers: [
        SharedService
    ]
})

export class PatientAppViewModule { }
